import { FC } from 'react';
import { getCommonCodeLabel } from '../../../../lib/store';
import { ILevelUpStudent } from '../../../../models/semesters.model';
import LevelUpTableHeader from './LevelUpTableHeader';
import LevelUpListModalHeader from './LevelUpListModalHeader';
import { useTranslation } from 'react-i18next';

interface IProps {
  data: ILevelUpStudent[] | undefined;
  isModal?: boolean;
}

const LevelUpTable: FC<IProps> = ({ data, isModal = false }) => {
  const { i18n } = useTranslation();
  const handleScore = (score: number | null) => {
    if (score === null) {
      return '';
    }
    return Math.round(score);
  };

  return (
    <div className='comm-table__area line-type mt-0'>
      <table>
          {isModal ? <LevelUpListModalHeader /> : <LevelUpTableHeader />}
          {/* <LevelUpTableHeader /> */}
          {data?.map((item, index) => (
            <>
              <tbody>
                <tr key={index}>
                  <td className="align-middle" rowSpan={2}>
                    {i18n.language==='ko'?item.campusKorName:item.campusEngName}
                  </td>
                  <td className="align-middle" rowSpan={2}>
                    {i18n.language==='ko'?item.memberKorName:item.memberEngName}
                  </td>
                  <td className="align-middle" rowSpan={2}>
                    {item.className}
                  </td>
                  <td className="align-middle" rowSpan={2}>
                    {item.studentRegisterCount}
                  </td>
                  <td>{item.monthlyTestScore1}</td>
                  <td>{item.monthlyTestScore2}</td>
                  <td>{item.levelTestScore}</td>
                  <td>{handleScore(item.icoachingAvgScore)}</td>
                  <td>{handleScore(item.elearningAvgScore)}</td>
                  <td>{item?.totalTestScore?.toFixed(1) || ''}</td>
                  <td className="align-middle" rowSpan={2}>
                    {getCommonCodeLabel('GR0005', item.levelUpResultCode, i18n.language)}
                  </td>
                  <td className="align-middle" rowSpan={2}>
                    {getCommonCodeLabel(
                      'GR0005',
                      item.campusLevelUpResultCode,
                      i18n.language,
                    )}
                  </td>
                  <td className="align-middle" rowSpan={2}>
                    {item.nextCourseName}
                  </td>
                </tr>
                <tr>
                  <td>{item.monthlyTestConversionScore1}</td>
                  <td>{item.monthlyTestConversionScore2}</td>
                  <td>{item.levelTestConversionScore}</td>
                  <td>{handleScore(item.icoachingConversionScore)}</td>
                  <td>{handleScore(item.elearningConversionScore)}</td>
                  <td>{item?.totalConversionScore?.toFixed(1) || ''}</td>
                </tr>
              </tbody>
            </>
          ))}
      </table>
    </div>
  );
};

export default LevelUpTable;
